import q from 'qj/q';
import E from 'qj/E';
import qq from 'qj/qq';
import aquireId from 'qj/aquireId';

const getItems = (elm: Element) => qq<HTMLElement>('.AccordionList__item', elm);

const initializeItem = (itemElm: HTMLElement) => {
	const titleElm = q<HTMLElement>('.AccordionList__title', itemElm);
	const contentElm = q<HTMLElement>('.AccordionList__content', itemElm);
	if (titleElm && contentElm) {
		let open = false;
		aquireId(contentElm);
		contentElm.hidden = !open;

		const buttonElm = E(
			'button',
			{
				className: 'AccordionList__button',
				'aria-controls': contentElm.id,
				onClick: () => {
					open = !open;
					if (open) {
						buttonElm.setAttribute('aria-expanded', 'true');
					} else {
						buttonElm.removeAttribute('aria-expanded');
					}
					contentElm.hidden = !open;
				},
			},
			titleElm.childNodes
		);
		titleElm.textContent = '';
		titleElm.appendChild(buttonElm);
	}
};

// init
document
	.querySelectorAll('.AccordionList')
	.forEach((acc) => getItems(acc).forEach(initializeItem));
